/* RESPONSIBLE TEAM: team-standalone */

import Controller from '@ember/controller';
import { action } from '@ember/object';

export default class AppStandaloneDeployFreshdeskTicketsGoLiveController extends Controller {
  // Using queryParams is the recommended usage for controllers in this codebase
  queryParams = ['openSection'];

  // Default value for query param
  openSection: string | null = null;

  @action
  setSection(sectionId: string | null) {
    this.openSection = sectionId;
  }
}
